<template>
    <div class="edit_wrap">
        <div class="edit_top">
            <div class="edit_tab active_tab">供应商信息</div><!--
    --><div class="edit_tab">品牌信息</div><!--
    --><div class="edit_tab">财务信息</div><!--
    --><div class="edit_tab">合同协议</div>
        </div>
        <div class="tip_word">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">友情提示：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<a target="_blank" href="/suppliers/index2/#/intro"><span style="color: #58b7ff">点击此处</span></a>查看供应商入驻介绍。</div></el-col>
            </el-row>
        </div>
        <div class="pl10 mt20">
            <div class="mt20 mb20"v-show="showSchedule" >
                <el-row>
                    <el-col :span="2">
                        <div class="grid-content">入驻进展：</div>
                    </el-col>
                    <el-col :span="22"><div class="grid-content"><span class="main_word">{{ scheduleObj.schedule }}</span></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="22" :offset="2"><div class="grid-content" v-if="scheduleObj.content">
                        ({{scheduleObj.content}})</div></el-col>
                </el-row>
            </div>
            <span class="dib">基础信息</span><span class="line"></span>
            <div class="mt20">
                <el-form :model="basicForm" :rules="rules" ref="basicForm" label-width="207px" class="demo-ruleForm">
                    <!-- 基础信息 -->
                    <el-form-item label="公司名称" prop="supplierName">
                        <el-input class="w500" v-model="basicForm.supplierName" placeholder="请输入营业执照注册的公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="公司介绍" prop="supplierIntro" class="dib">
                        <el-input class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea"
                                  v-model="basicForm.supplierIntro" placeholder="请详细介绍公司信息，如行业地位等"
                                  :maxlength="200"></el-input>
                    </el-form-item>
                    <span class="word_num">您可以输入 <span class="main_word">{{ amount }}</span> 个字</span>
                    <el-form-item label="线上店铺" prop="otherPlatformShopUrl">
                        <el-input class="w500" v-model="basicForm.otherPlatformShopUrl" placeholder="其他平台商品、店铺的链接">
                        </el-input>
                    </el-form-item>
                    <!--{{basicForm.officeCountry}}-->
                    <el-form-item label="办公地址" class="dib">
                        <span class="main_word rule_star vtb">*</span>
                        <el-select class="ml_10" v-model="basicForm.officeCountry" placeholder="请选择国家" @change="getOfficeProvince">
                            <el-option v-for="val in countryList" :label="val.name" :value="val.id"
                                       :key="val.id">
                            </el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isForeign" v-model="basicForm.officeProvince" placeholder="请选择省份"
                                   @change="getOfficeCity">
                            <el-option v-for="val in provinceList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isForeign" v-model="basicForm.officeCity" placeholder="请选择城市"
                                   @change="getOfficeDistrict">
                            <el-option v-for="val in cityList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isForeign" v-model="basicForm.officeDistrict" placeholder="请选择区县">
                            <el-option v-for="val in districtList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="officeAddress" label-width="207px">
                        <el-input class="w500" :autosize="{ minRows: 4, maxRows: 6}" type="textarea"
                                  v-model="basicForm.officeAddress" placeholder="请输入您的详细地址"></el-input>
                    </el-form-item>
                    <span class="dib">品类信息</span><span class="line"></span>
                    <!--{{cata.first}}-->
                    <el-form-item v-show=" applyStatus != 9 " label="申请主营品类：" class="dib mt20">
                        <span class="main_word rule_star2 vtb">*</span>
                        <el-select class="ml_10 vtb" v-model="cata.first" placeholder="请选择一级类目"
                                   @change="getTowList">
                            <el-option v-for="val in oneList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <!-- {{cata.second}} -->
                    <el-form-item v-show=" applyStatus != 9 " class="dib sign">
                        <el-select class="vtb" v-model="cata.second" placeholder="请选择二级类目"
                                   @change="getThreeList">
                            <el-option v-for="val in twoList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <!-- {{cata.categoryId}} -->
                    <el-form-item v-show=" applyStatus != 9 " class="dib sign">
                        <el-select class="vtb" @change="selectInfo" v-model="cata.categoryId"
                                   placeholder="请选择三级类目">
                            <el-option v-for="val in threeList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                            <!-- <el-option label="区域二" value="beijing"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-button class="vtb" v-show=" applyStatus != 9 " type="primary" @click="addDomain">添加合作类目</el-button>

                    <el-table :data="supplierApplyCategories" border style="width: 84%;margin: 0 auto;margin-bottom:22px"
                    >
                        <el-table-column
                                label="主营品类"
                                width="300"
                                align="center">
                            <template scope="scope">
                                <span>{{ scope.row.category.grandName }}--</span>
                                <span>{{ scope.row.category.parentName }}--</span>
                                <span>{{ scope.row.category.childrenName }}</span>
                                <!--<span>{{ scope.row.categoryName }}</span>-->
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="categoryDeposit"
                                label="品类保证金"
                                width="271"
                                align="center">
                            <template>
                                <div class="red">
                                    <el-table-column
                                            prop="categoryDeposit"
                                            label="(只需上交保证金额最高的一个)"
                                            width="271"
                                            align="center">
                                    </el-table-column>
                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                            <template scope="scope" >
                                <el-upload class="hide_up" v-show="scope.row.franchiseQualification"
                                           style="max-height: 149px;overflow: hidden;"
                                        action="/suppliers/uploadImageData?biz=0"
                                        name="pic"
                                        :data="{data:scope.$index}"
                                        list-type="picture-card"
                                        :file-list="scope.row.franchiseQualificationFile"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="handleRemove"
                                        :on-success="handleUpload"
                                        :before-upload="beforeUpload"
                                        :class="[scope.row.franchiseQualificationFile.length > 1 ? franchise[scope.$index]: '']"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center"  v-if="applyStatus != 9 ">
                            <template scope="scope" >
                                <el-button  v-show=" applyStatus != 9 "
                                        size="small"
                                        type="danger"
                                        @click="handleDelete(scope.$index, scope.row)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <span class="dib mb20">供应商资质信息</span><span class="second_line"></span>
                    <!--{{basicForm.publicationBusinessLicenseFile}}-->
                    <el-form-item v-show="isBook" label="出版社经营许可证电子版：" class="dib">
                        <span class="main_word rule_star3">*</span>
                        <span class="f666 f12">复印件需加盖公司红章扫描上传</span>
                        <template v-show="!pic_1">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0"
                                       name="pic"
                                       :file-list="basicForm.publicationBusinessLicenseFile"
                                       list-type="picture-card"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="removePic1"
                                       :before-upload="beforeUpload"
                                       :on-success="handleSuccess1">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_1" class="pic_tip">请上传图片</p>
                    </el-form-item>

                    <el-form-item label="注册登记名称：" prop="registeredName">
                        <el-input class="w500" v-model="basicForm.registeredName" placeholder="请输入注册登记名称"></el-input>
                    </el-form-item>
                    <!-- 注册登记地址 -->
                    <!--{{basicForm.registeredCountry}}-->
                    <el-form-item label="注册登记地址：" class="dib" prop="registeredCountry">
                        <el-select :disabled="isBook || applyStatus ==9" v-model="basicForm.registeredCountry" placeholder="请选择国家"
                                   @change="getRegisteredProvince">
                            <el-option v-for="val in countryList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredProvince"
                                   placeholder="请选择省份" @change="getRegisteredCity">
                            <el-option v-for="val in registeredProvinceList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredCity" placeholder="请选择城市"
                                   @change="getRegisteredDistrict">
                            <el-option v-for="val in registeredCityList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="dib sign">
                        <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredDistrict"
                                   placeholder="请选择区县">
                            <el-option v-for="val in registeredDistrictList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="registeredAddress" label-width="207px">
                        <el-input class="w500" :autosize="{ minRows: 4, maxRows: 6}" type="textarea"
                                  v-model="basicForm.registeredAddress" placeholder="请输入您的详细地址"></el-input>
                    </el-form-item>
                    <!-- 注册资金 -->
                    <el-form-item label="注册资金：" prop="registeredCapital"
                                  :rules="[
              { required: true, message: '注册资金不能为空'},
              { type: 'number', message: '请输入数字值'}
            ]">
                        <el-input class="w500" v-model.number="basicForm.registeredCapital"
                                  placeholder="请输入注册资金"></el-input>
                        （单位：万）
                        <el-radio-group v-model="basicForm.registeredCapitalType">
                            <el-radio :label="1"><span class="f14 f666">人民币</span></el-radio>
                            <el-radio :label="2"><span class="f14 f666">美元</span></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 执照类型 -->
                    <el-form-item label="执照类型：" v-show="basicForm.licenseType !=3">
                        <el-radio-group v-model="basicForm.licenseType" @change="licenseChange">
                            <el-radio :label="1"><span class="f14 f666">普通营业执照</span></el-radio>
                            <el-radio :label="2"><span class="f14 f666">三证合一／五证合一</span></el-radio>
                            <el-radio v-show="false" :label="3"><span class="f14 f666">国外</span></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 营业执照号 -->
                    <el-form-item label="营业执照号：" prop="businessLicenseCode"
                                  :rules="[
              { required: true, message: '营业执照号不能为空', trigger: 'blur'}

            ]">
                        <el-input class="w500" v-model="basicForm.businessLicenseCode"
                                  placeholder="请输入营业执照号"></el-input>
                    </el-form-item>
                    <!-- 营业执照电子版 -->
                    <el-form-item label="营业执照电子版：" class="dib mt20">
                        <span class="main_word rule_star4">*</span>
                        <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                        <template v-show="!pic_2">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.businessLicenseFile"
                                       list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePic2"
                                       :on-success="handleSuccess2" :before-upload="beforeUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_2" class="pic_tip">请上传图片</p>
                    </el-form-item>
                    <!-- 执照有限期 -->
                    <el-form-item v-show="basicForm.registeredCountry == 1" label="执照有效期：">
                        <span class="main_word rule_star105">*</span>
                        <el-date-picker class="ml_10" v-model="value6" type="daterange"
                                        placeholder="选择执照有效期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- 组织机构代码 -->
                    <el-form-item v-show="isOneCertificate" label="组织机构代码：">
                        <span class="main_word rule_star2 vtb">*</span>
                        <el-input class="w500 ml_10" v-model="basicForm.orgCode" placeholder="请输入组织机构代码"></el-input>
                    </el-form-item>
                    <!-- 组织结构代码电子版 -->
                    <el-form-item v-show="isOneCertificate" label="组织结构代码电子版：" class="dib mt20">
                        <span class="main_word rule_star5">*</span>
                        <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                        <template v-show="!pic_3">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.orgCodeFile"
                                       list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePic3"
                                       :on-success="handleSuccess3" :before-upload="beforeUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_3" class="pic_tip">请上传图片</p>
                    </el-form-item>
                    <!-- 税务登记证电子版 -->
                    <el-form-item v-show="isOneCertificate" label="税务登记证电子版：" class="dib mt20">
                        <span class="main_word rule_star6">*</span>
                        <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                        <template v-if="!pic_4">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.taxFile"
                                       list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePic4"
                                       :on-success="handleSuccess4" :before-upload="beforeUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_4" class="pic_tip">请上传图片</p>
                    </el-form-item>
                    <!-- 开户许可证电子版 -->
                    <el-form-item label="开户许可证电子版：" class="dib mt20">
                        <span class="main_word rule_star6">*</span>
                        <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                        <template v-show="!pic_5">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.accountOpeningPermitFile"
                                       list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePic5"
                                       :on-success="handleSuccess5" :before-upload="beforeUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_5" class="pic_tip">请上传图片</p>
                    </el-form-item>
                    <!-- 法定代表人证件类型 -->
                    <el-form-item label="法定代表人证件类型：" class="mt20">
                        <span class="main_word rule_star5">*</span>
                        <el-radio-group class="ml_10" v-model="basicForm.personalCardType">
                            <el-radio :label="1"><span class="f14 f666">身份证</span></el-radio>
                            <el-radio :label="2"><span class="f14 f666">护照</span></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 法定代表人身份证件电子版 -->
                    <el-form-item label="法定代表人身份证件电子版：" class="dib mt20">
                        <span class="main_word rule_star200">*</span>
                        <span class="f666 f12 ml_10">身份证正反两面，同一张A4纸，复印件请加盖公司红章</span>
                        <template v-show="!pic_6">
                            <div class="fixeds"></div>
                        </template>
                        <template>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.personalCardFile"
                                       list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePic6"
                                       :on-success="handleSuccess6" :before-upload="beforeUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </template>

                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                        <p v-show="pic_6" class="pic_tip">请上传图片</p>
                    </el-form-item>
                    <div>
                        <span class="dib">业务联系人信息</span><span class="second_line"></span>
                    </div>
                    <!-- 联系人姓名 -->
                    <el-form-item class="mt20" label="联系人姓名:" prop="contactName">
                        <el-input class="w500" v-model="basicForm.contactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                    </el-form-item>
                    <!-- 联系人手机号 -->
                    <el-form-item label="联系人手机号:" prop="contactMobile">
                        <el-input class="w500" v-model="basicForm.contactMobile" placeholder="请输入联系人手机号"></el-input>
                    </el-form-item>
                    <!-- 联系人座机 -->
                    <el-form-item label="联系人座机:">
                        <el-input class="w500" v-model="basicForm.contactLandline" placeholder="请输入联系人座机"></el-input>
                    </el-form-item>
                    <!-- 联系人邮箱 -->
                    <el-form-item label="联系人邮箱:" prop="contactEmail"
                                  :rules="[
				      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
				      { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
				    ]">
                        <el-input class="w500" v-model="basicForm.contactEmail" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                    <!-- 联系人QQ -->
                    <el-form-item label="联系人QQ:" prop="contactQQ">
                        <el-input class="w500" v-model="basicForm.contactQQ"
                                  placeholder="请输入联系人QQ"></el-input>
                    </el-form-item>
                    <!-- 职务 -->
                    <el-form-item label="职务:" prop="contactPosition">
                        <el-input class="w500" number v-model.number="basicForm.contactPosition"
                                  placeholder="请输入联系人职务"></el-input>
                    </el-form-item>

                    <div>
                        <span class="dib">合同联系人信息</span><span class="second_line"></span>
                    </div>
                    <!-- 联系人姓名 -->
                    <el-form-item class="mt20" label="联系人姓名:" prop="contractContactName">
                        <el-input class="w500" v-model="basicForm.contractContactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                    </el-form-item>
                    <!-- 联系人手机号 -->
                    <el-form-item label="联系人手机号:" prop="contractContactMobile">
                        <el-input class="w500" v-model="basicForm.contractContactMobile" placeholder="请输入联系人手机号"></el-input>
                    </el-form-item>
                    <!-- 联系人座机 -->
                    <el-form-item label="联系人座机:">
                        <el-input class="w500" v-model="basicForm.contractContactLandline" placeholder="请输入联系人座机"></el-input>
                    </el-form-item>
                    <!-- 联系人邮箱 -->
                    <el-form-item label="联系人邮箱:" prop="contractContactEmail"
                                  :rules="[
				      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
				      { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
				    ]">
                        <el-input class="w500" v-model="basicForm.contractContactEmail" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                    <!-- 联系人QQ -->
                    <el-form-item label="联系人QQ:" prop="contractContactQQ">
                        <el-input class="w500" v-model="basicForm.contractContactQQ"
                                  placeholder="请输入联系人QQ"></el-input>
                    </el-form-item>
                    <!-- 职务 -->
                    <el-form-item label="职务:" prop="contractContactPosition">
                        <el-input class="w500" number v-model.number="basicForm.contractContactPosition"
                                  placeholder="请输入联系人职务"></el-input>
                    </el-form-item>

                    <div>
                        <span class="dib">客服联系人信息</span><span class="second_line"></span>
                    </div>
                    <!-- 联系人姓名 -->
                    <el-form-item class="mt20" label="联系人姓名:" prop="customContactName">
                        <el-input class="w500" v-model="basicForm.customContactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                    </el-form-item>
                    <!-- 联系人手机号 -->
                    <el-form-item label="联系人手机号:" prop="customContactMobile">
                        <el-input class="w500" v-model="basicForm.customContactMobile" placeholder="请输入联系人手机号"></el-input>
                    </el-form-item>
                    <!-- 联系人座机 -->
                    <el-form-item label="联系人座机:">
                        <el-input class="w500" v-model="basicForm.customContactLandline" placeholder="请输入联系人座机"></el-input>
                    </el-form-item>
                    <!-- 联系人邮箱 -->
                    <el-form-item label="联系人邮箱:" prop="customContactEmail"
                                  :rules="[
				      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
				      { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
				    ]">
                        <el-input class="w500" v-model="basicForm.customContactEmail" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                    <!-- 联系人QQ -->
                    <el-form-item label="联系人QQ:" prop="customContactQQ">
                        <el-input class="w500" v-model="basicForm.customContactQQ"
                                  placeholder="请输入联系人QQ"></el-input>
                    </el-form-item>
                    <!-- 职务 -->
                    <el-form-item label="职务:" prop="customContactPosition">
                        <el-input class="w500" number v-model.number="basicForm.customContactPosition"
                                  placeholder="请输入联系人职务"></el-input>
                    </el-form-item>

                    <el-form-item class="mt50" label-width="207px">
                        <el-button type="primary" v-if="applyStatus == 0 || applyStatus==1" class="mr30" @click="saveForm">保存草稿</el-button>
                        <el-button type="primary" @click="submitForm('basicForm')">下一步，完善品牌信息</el-button>
                    </el-form-item>

                    <!--预览图片弹框-->
                    <el-dialog :visible.sync="dialogVisible" size="small">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form>
            </div>

        </div>
        <!--<span v-loading.fullscreen.lock="fullLoading" element-loading-text="玩命加载中"></span>-->
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('手机号不能为空'));
                } else {
                    if (/^1[0-9]\d{9}$/.test(value) == false) {
                        callback(new Error('手机号格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            return {
//                fullLoading: true,
                value6: '',
                applyStatus:0,
                showSchedule:false,
                scheduleObj:{
                    schedule:"",
                    content:""
                },
                franchise:'franchise',
                officeProvinceInit: false,
                officeCityInit: false,
                officeDistrictInit: false,
                registeredProvinceInit: false,
                registeredCityInit: false,
                registeredDistrictInit: false,
                pic_1: false,
                pic_2: false,
                pic_3: false,
                pic_4: false,
                pic_5: false,
                pic_6: false,

                supplierApplyId: null,      // 供应商申请id
                success: false,     // 提交 数据是否成功
                businessLicenseStartDate: '',			// 开始时间
                businessLicenseEndDate: '',			// 结束时间
                dialogImageUrl: '',
                dialogVisible: false,
                isForeign: false,     // 办公地址是否是国外
                isRegisteredForeign: false,     // 注册 办公地址是否是国外
                isOneCertificate: true,    // 是否是三证合一/五证合一
                isBook: false,         // 品类是否是图书

                pic_1: false,			// 资质上传  出版社经营许可证电子版 提示
                countryList: [],                  // 国家地址列表
                provinceList: [],                  // 省份地址列表
                cityList: [],                  // 城市地址列表
                districtList: [],               // 区县列表

                oneList: [],        // 一级类目列表
                twoList: [],        // 二级类目列表
                threeList: [],      // 三级类目列表

                registeredProvinceList: [],                  // 注册 省份地址列表
                registeredCityList: [],                  // 注册 城市地址列表
                registeredDistrictList: [],               // 注册 区县列表
                imgList:'',
                typeIndex:'',



                typeImg:[],
                // 资质上传  出版社经营许可证电子版 数据
//                publicationBusinessLicenseFile: [],
                // 营业执照电子版
//                businessLicenseFile: [],
                // 组织结构代码电子版
//                orgCodeFile: [],
                // 税务登记证电子版
//                taxFile: [],
                // 开户许可证电子版
//                accountOpeningPermitFile: [],
                // 法定代表人身份证件电子版
//                personalCardFile: [],



                // isTable: true,								// 是否显示主营品类表格
                isAdd: false,									// 是否添加合作类目

                // 品类列表id
                cata: {
                    first: null,
                    second: null,
                    categoryId: null
                },
                // 品类表格
                supplierApplyCategories: [],

                // 品类tpm
                tpmList: {},
                franchiseQualificationFile: [],


                // 提交数据
                basicForm: {
                    supplierApplyId: 0,
                    supplierName: '',						// 供应商名称
                    supplierIntro: '',					// 供应商介绍
                    otherPlatformShopUrl: '',		// 其他平台店铺地址
                    officeCountry: null,					// 办公地址-国家
                    officeProvince: null,					// 办公地址-省份
                    officeCity: null,							// 办公地址-城市
                    officeDistrict: null,					// 办公地址-区县
                    officeAddress: '',					// 办公地址-详细地址
                    registeredCountry: null,					// 注册地址-国家
                    registeredProvince: null,					// 注册地址-省份
                    registeredCity: null,							// 注册地址-城市
                    registeredDistrict: null,					// 注册地址-区县
                    registeredAddress: '',					// 注册地址-详细地址
                    registeredCapital: '',			// 注册资金
//                    registeredPhone: '',				// 注册登记电话
                    businessLicenseCode: '',		// 营业执照号
                    orgCode: '',								// 组织机构代码
                    personalCardType: 1,				// 法定代表人证件类型
                    contactName: '',						// 联系人姓名
                    contactMobile: '',					// 联系人手机号
                    contactEmail: '',						// 联系人邮箱
                    contactQQ: '',							// 联系人QQ
                    contactPosition: '',				// 联系人职务
                    contactLandline: '',                // 联系人座机
                    dateTimes: '',       // 生效时间段

                    registeredName: '',					// 注册登记名称
                    // 资质上传  执照类型 数据
                    licenseType: 1,
                    // 注册资金 类型
                    registeredCapitalType: 1,

                    // 资质上传  出版社经营许可证电子版 数据
                    publicationBusinessLicenseFile: [],
                    // 营业执照电子版
                    businessLicenseFile: [],
                    // 组织结构代码电子版
                    orgCodeFile: [],
                    // 税务登记证电子版
                    taxFile: [],
                    // 开户许可证电子版
                    accountOpeningPermitFile: [],
                    // 法定代表人身份证件电子版
                    personalCardFile: [],

                    contractContactName: '',						// 联系人姓名
                    contractContactMobile: '',					// 联系人手机号
                    contractContactEmail: '',						// 联系人邮箱
                    contractContactQQ: '',							// 联系人QQ
                    contractContactPosition: '',				// 联系人职务
                    contractContactLandline: '',                // 联系人座机

                    customContactName: '',						// 联系人姓名
                    customContactMobile: '',					// 联系人手机号
                    customContactEmail: '',						// 联系人邮箱
                    customContactQQ: '',							// 联系人QQ
                    customContactPosition: '',				// 联系人职务
                    customContactLandline: '',                // 联系人座机
                },
                rules: {
                    supplierName: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                        {max: 150, message: '最多输入150个字符', trigger: 'blur'}
                    ],
                    supplierIntro: [
                        {required: true, message: '请输入公司介绍', trigger: 'blur'},
                        {max: 200, message: '最多输入200个字', trigger: 'blur'}
                    ],
                    otherPlatformShopUrl: [
                        {required: true, message: '请输入线上店铺链接', trigger: 'blur'},
                    ],

                    officeProvince: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeCity: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeDistrict: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeAddress: [
                        {required: true, message: '请填写完整办公地址', trigger: 'blur'},
                        {max: 50, message: '最多输入50个字', trigger: 'blur'}
                    ],
                    registeredName: [
                        {required: true, message: '请输入注册登记名称', trigger: 'blur'},
                    ],
                    registeredCountry: [
                        {required: true, type: 'number', message: '请选择注册登记地址', trigger: 'blur'},
                    ],
                    registeredProvince: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredCity: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredDistrict: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredAddress: [
                        {required: true, message: '请输入详细注册地址', trigger: 'blur'},
                    ],
                    orgCode: [
                        {required: true, message: '请输入组织机构代码', trigger: 'blur'},
                    ],
                    contactName: [
                        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    contactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    contactQQ: [
                        {required: true, message: '请输入联系人QQ', trigger: 'blur'}
                    ],
                    contractContactName: [
                        {required: true, message: '请输入合同联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    contractContactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    contractContactQQ: [
                        {required: true, message: '请输入合同联系人QQ', trigger: 'blur'}
                    ],
                    customContactName: [
                        {required: true, message: '请输入客服联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    customContactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    customContactQQ: [
                        {required: true, message: '请输入客服联系人QQ', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            getTimeStr (val) {
                var date = new Date(val);
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = date.getDate() + ' ';
                return Y+M+D;
            },
            fetch () {
                var _this = this;
                //var supplierApplyId = sessionStorage.getItem("supplierApplyId");
                var supplierApplyId = this.$route.query.supplierApplyId;
                console.log(supplierApplyId)
                if(!supplierApplyId){
                    supplierApplyId=0
                }
                _this.supplierApplyId = supplierApplyId;
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApply',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
//                            _this.fullLoading = false;
                            var status = result.data.status;
                            supplierApplyId = result.data.supplierApplyId;
                            if(supplierApplyId){
                                _this.supplierApplyId = supplierApplyId;
                                _this.applyStatus = status;
                                if(status!=1 && status!=3 && status!=9) {
                                    if(status == 5) {
                                        // 后台成功 改变路由
                                        _this.$router.push({
                                            path:'/supplier_apply_audit',
                                            query:{supplierApplyId: supplierApplyId}
                                        })
                                    }else{
                                        // 后台成功 改变路由
                                        _this.$router.push({
                                            path:'/supplier_skan',
                                            query:{supplierApplyId: supplierApplyId}
                                        })
                                    }
                                }
                                _this.basicForm = result.data;
//                                var Stime = new Date(result.data.businessLicenseStartDate);
//                                var Etime = new Date(result.data.businessLicenseEndDate);
//                                _this.basicForm.dateTime = [Stime,Etime];
//                                console.log(_this.basicForm.dateTime)



                                _this.supplierApplyCategories = result.data.supplierApplyCategories;
                                if(_this.supplierApplyCategories.length>0){
                                    for (var i=0;i<_this.supplierApplyCategories.length;i++) {
                                        _this.supplierApplyCategories[i].deptId = _this.basicForm.categoryDeptId;
                                        if (_this.supplierApplyCategories[i].franchiseQualification){
                                            _this.supplierApplyCategories[i].franchiseQualificationFile = _this.fileTrans(_this.supplierApplyCategories[i].franchiseQualificationFile)
                                        }else{
                                            _this.supplierApplyCategories[i].franchiseQualificationFile = [];
                                        }
                                    }

                                }
                                _this.basicForm.publicationBusinessLicenseFile = _this.fileTrans(result.data.publicationBusinessLicenseFile);
                                _this.basicForm.businessLicenseFile = _this.fileTrans(result.data.businessLicenseFile);
                                _this.basicForm.orgCodeFile = _this.fileTrans(result.data.orgCodeFile);
                                _this.basicForm.taxFile = _this.fileTrans(result.data.taxFile);
                                _this.basicForm.accountOpeningPermitFile = _this.fileTrans(result.data.accountOpeningPermitFile);
                                _this.basicForm.personalCardFile = _this.fileTrans(result.data.personalCardFile);
                                _this.licenseChange(_this.basicForm.licenseType);

                                if(_this.basicForm.categoryIsBook == 1) {
                                    _this.isBook = true;
                                }
                                _this.initProgress(supplierApplyId);

                                var Stime = result.data.businessLicenseStartDate;
                                var Etime = result.data.businessLicenseEndDate;
                                _this.value6=[Stime,Etime];

                            }
                            //_this.getOfficeProvince();
                            //_this.getRegisteredProvince();
                        } else if(result.code == 10067 || result.code == 10100) {
                            window.location.href = "/suppliers/index";
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            initProgress(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/schedule',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (result && !result.code) {
                            that.showSchedule = true;
                            that.scheduleObj=result.data;
                        } else {

                        }
                    }
                })
            },
            // 删除品类
            handleDelete(index, row) {
                this.supplierApplyCategories.map((item, num) => {
                    if (index == num) {
                        this.supplierApplyCategories.splice(num, 1);
                    }
                    return item;
                })

                if( this.supplierApplyCategories.length<=0) {
                    this.isBook = false;
                    this.basicForm.registeredCountry = null;
                    window.sessionStorage["categoryIsBook"] = 0;
                }
            },
            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if(fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        array.push(file);
                    }
                }
                return array;
            },
            // [] 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },
            // 时间转换
            transform (val) {
                console.log(val)
                var arr = val.split(" - ");

                // var str = val[0].toString();

                this.businessLicenseStartDate = new Date(arr[0]).getTime();
                this.businessLicenseEndDate = new Date(arr[1]).getTime();
                this.basicForm.dateTimes.push(this.businessLicenseStartDate)
                this.basicForm.dateTimes.push(this.businessLicenseEndDate)
//                 var ttime = new Date('2017-04-01').getTime();
                // console.log(ttime)
            },
            timeChange (val) {
                console.log(val)
            },
            // 请求三级类目 数据
            selectInfo() {
                var _this = this;
                console.log(_this.cata);
                console.log(_this.cata.categoryId);
                var id = _this.cata.categoryId;
                $.get({
                    url: '/suppliers/supplierSettled/findGoodsCategoryAttribute',
                    data: {
                        categoryId: id
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.tpmList = result.data;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            addType(index) {
                console.log(this.domain.categoryId)
                console.log(index);
            },
            // 添加合作类目
            addDomain() {
                if ($.isEmptyObject(this.tpmList)) {
                    this.$message.error('请选择主营品类类目');
                    return;
                } else if (this.supplierApplyCategories.length > 0 && this.supplierApplyCategories[0].deptId !=this.tpmList.deptId) {
                    this.$message.error('主营品类所属部门不一致');
                    return;
                } else if (this.cata.first== 2110 && !this.isBook && this.supplierApplyCategories.length>0) {
                    this.$message.error('已选择非图书品类，不能再选择图书');
                    return;
                } else if (this.cata.first !=2110 && this.isBook) {
                    this.$message.error('已选择图书品类，不能再选择非图书');
                    return;
                }
                if(this.supplierApplyCategories){
                    var isAdd = false;
                    this.supplierApplyCategories.map((item,num) => {
                        if(item.category.childrenId==this.tpmList.category.childrenId){
                            isAdd=true;
                            return;
                        }
                    });
                    if(isAdd) {
                        this.$message.error('不可添加重复品类');
                        return;
                    }
                }

                if (this.tpmList.category.grandId == 2110) {
                    this.basicForm.registeredCountry = 1;
                    this.isRegisteredForeign = false;
                    this.isBook = true;
                    window.sessionStorage["categoryIsBook"] = 1;
                    this.tpmList.franchiseQualificationFile = [];
                    this.supplierApplyCategories.push(this.tpmList)
                    // 添加成功之后
                    this.cata.first = null;
                    this.tpmList = {};
                } else {
                    //this.basicForm.registeredCountry = null;
                    this.isBook = false;
                    window.sessionStorage["categoryIsBook"] = 0;
                    this.tpmList.franchiseQualificationFile = [];
                    this.supplierApplyCategories.push(this.tpmList)
                    // 添加成功之后
                    this.cata.first = null;
                    this.tpmList = {};
                }
            },

            // 删除 品类信息 上传图片
            handleRemove(file) {
                this.supplierApplyCategories.map((item,num) => {
                    if(item.uid && item.uid == file.uid) {
                        item.franchiseQualificationFile =  [];
                    }
                    return item;
                });
            },
            // 预览 品类信息 图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
//                $(".categoryUpload").parent('.el-upload').css('display', "none");
                $(".el-upload-list__item").css('margin-bottom', "10px");
            },
            handleUpload(response,file) {
                var index=parseInt(response.otherData);
                if (!response.code) {
                    this.supplierApplyCategories.map((item,num) => {
                        if(index == num) {
                            item.franchiseQualificationFile =  this.fileTrans(response.data);
                            item.uid = file.uid;
                        }
                        return item;
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }


//                    this.franchiseQualificationFile.push("");

//                console.log(row);
//                console.log(data);
//                var obj = {
//                    id: row[index].categoryId,
//                    img:''
//                }
//                this.typeImg.push();

            },
            handleChange(file) {
//               console.log(file);
//                this.typeIndex = file.uid;
//                this.typeList.push()
            },
            // 上传成功
            handleSuccess1(response, file) {
//                this.imgList = file.url
//                this.basicForm.publicationBusinessLicenseFile[0] = file.url;
//                console.log(this.basicForm.publicationBusinessLicenseFile[0])
//                console.log(this.basicForm.publicationBusinessLicenseFile)
                if (!response.code) {
                    this.basicForm.publicationBusinessLicenseFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            handleSuccess2(response, file) {
                if (!response.code) {
                    this.basicForm.businessLicenseFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            handleSuccess3(response, file) {
                if (!response.code) {
                    this.basicForm.orgCodeFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }

            },
            handleSuccess4(response, file) {
                if (!response.code) {
                    this.basicForm.taxFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }

            },
            handleSuccess5(response, file) {

                if (!response.code) {
                    this.basicForm.accountOpeningPermitFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }

            },
            handleSuccess6(response, file) {

                if (!response.code) {
                    this.basicForm.personalCardFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            removePic1 () {
                this.basicForm.publicationBusinessLicenseFile = [];
            },
            removePic2 () {
                this.basicForm.businessLicenseFile = [];
            },
            removePic3 () {
                this.basicForm.orgCodeFile = [];
            },
            removePic4 () {
                this.basicForm.taxFile = [];
            },
            removePic5 () {
                this.basicForm.accountOpeningPermitFile = [];
            },
            removePic6 () {
                this.basicForm.personalCardFile = [];
            },
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                console.log(isJPG)
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }
            },


            // 请求一级地址
            getAddress () {
                var _this = this;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '1',
                        regionId: ''
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.countryList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            getOfficeProvince () {
                var _this = this;
                var regionId = this.basicForm.officeCountry;
                if (this.officeProvinceInit) {
                    this.basicForm.officeProvince = null;
                    this.basicForm.officeCity = null;
                    this.basicForm.officeDistrict = null;
                }

                if (regionId == 1) {
                    this.isForeign = false;
                } else {
                    this.isForeign = true;
                }
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '2',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
//                            console.log(result.data)
                            _this.provinceList = result.data.list;
                            _this.officeProvinceInit = true;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            getOfficeCity () {
                if(this.officeCityInit){
                    this.basicForm.officeCity = null;
                    this.basicForm.officeDistrict = null;
                }
                var _this = this;
                var regionId = this.basicForm.officeProvince;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '3',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
                            console.log(result.data)
                            _this.cityList = result.data.list;
                            _this.officeCityInit = true;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            getOfficeDistrict () {
                if(this.officeDistrictInit){
                    this.basicForm.officeDistrict = null;
                }
                var _this = this;
                var regionId = this.basicForm.officeCity;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '4',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
                            console.log(result.data)
                            _this.districtList = result.data.list;
                            _this.officeDistrictInit=true;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求一级类目
            getCategory () {
                var _this = this;
                $.get({
                    url: '/suppliers/supplierSettled/findCategoryApplication',
                    data: {
                        type: '1',
                        categoryId: ''
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.oneList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求二级类目
            getTowList (value) {
                this.cata.second = null;
                var _this = this;
                if (value == 2110) {
//                    this.isBook = true;
                    //this.basicForm.registeredCountry = null;
                    //this.isRegisteredForeign = false;
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '2',
                            regionId: '1'
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.registeredProvinceList = result.data.list;
                            }
                        }
                    });
                } else {
//                    this.isBook = false;
                }
                $.get({
                    url: '/suppliers/supplierSettled/findCategoryApplication',
                    data: {
                        type: '2',
                        categoryId: value
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.twoList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求三级类目
            getThreeList (value) {
                this.cata.categoryId = null;
                var _this = this;
                $.get({
                    url: '/suppliers/supplierSettled/findCategoryApplication',
                    data: {
                        type: '3',
                        categoryId: value
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.threeList = result.data.list;
                        } else {
                            // _this.$message({
                            //   showClose: true,
                            //   message: result.msg,
                            //   type: 'error'
                            // });
                        }
                    }
                })
            },
            // 请求 注册省份列表
            getRegisteredProvince () {
                var _this = this;
                var value = this.basicForm.registeredCountry;
                if(this.registeredProvinceInit){
                    this.basicForm.registeredProvince = null;
                    this.basicForm.registeredCity = null;
                    this.basicForm.registeredDistrict = null;
                }
                if (value == 1) {
                    this.isRegisteredForeign = false;
                    if(this.basicForm.licenseType==3){
                        this.basicForm.licenseType = 1;
                    }
                } else if (value && value != 1) {
                    this.isRegisteredForeign = true;
                    this.basicForm.licenseType = 3;
                }
                if (value == 1) {

                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '2',
                            regionId: '1'
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.registeredProvinceList = result.data.list;
                                _this.registeredProvinceInit = true;
                            } else {
//                                _this.$message({
//                                    showClose: true,
//                                    message: result.msg,
//                                    type: 'error'
//                                });
                            }
                        }
                    })
                } else {
                    this.registeredProvinceList = [];
                }
            },
            // 请求 注册城市列表
            getRegisteredCity () {
                var value = this.basicForm.registeredProvince;
                var _this = this;
                if (this.registeredCityInit){
                    this.basicForm.registeredCity = null;
                    this.basicForm.registeredDistrict = null;
                }
                if (value) {
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '3',
                            regionId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.registeredCityList = result.data.list;
                                _this.registeredCityInit = true;
                            } else {
//                                _this.$message({
//                                    showClose: true,
//                                    message: result.msg,
//                                    type: 'error'
//                                });
                            }
                        }
                    })
                } else {
                    this.registeredCityList = [];
                }
            },
            // 请求 注册区县列表
            getRegisteredDistrict () {
                var value = this.basicForm.registeredCity;
                var _this = this;
                if(this.registeredDistrictInit){
                    this.basicForm.registeredDistrict = null;
                }
                if (value) {
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '4',
                            regionId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.registeredDistrictList = result.data.list;
                                _this.registeredDistrictInit = true;
                            } else {
//                                _this.$message({
//                                    showClose: true,
//                                    message: result.msg,
//                                    type: 'error'
//                                });
                            }
                        }
                    })
                } else {
                    this.registeredDistrictList = [];
                }
            },
            // 执照类型变化
            licenseChange (val) {
                if (val == 2 || val == 3) {
                    this.isOneCertificate = false;
                } else {
                    this.isOneCertificate = true;
                }
            },
            saveForm () {
                var _this = this;
                var Data = {};
                // Data.supplierApplyCategories = [];

                Data = JSON.parse(JSON.stringify(this.basicForm));
                // 上传图片
                console.log(typeof (this.basicForm.businessLicenseFile));
//                Data.publicationBusinessLicenseFile = JSON.stringify(this.basicForm.publicationBusinessLicenseFile[0]);

                Data.publicationBusinessLicenseFile = this.fileTransToString(this.basicForm.publicationBusinessLicenseFile);

//                if(this.basicForm.businessLicenseFile.length > 0) {
//                    Data.businessLicenseFile = JSON.stringify(this.basicForm.businessLicenseFile[0]);
//                }
//                Data.businessLicenseFile = this.basicForm.businessLicenseFile[0];
                Data.businessLicenseFile = this.fileTransToString(this.basicForm.businessLicenseFile);
                Data.orgCodeFile = this.fileTransToString(this.basicForm.orgCodeFile);

//                Data.orgCodeFile = this.basicForm.orgCodeFile[0];
                Data.taxFile = this.fileTransToString(this.basicForm.taxFile);

//                Data.taxFile = this.basicForm.taxFile[0];
                Data.accountOpeningPermitFile = this.fileTransToString(this.basicForm.accountOpeningPermitFile);

//                Data.accountOpeningPermitFile = this.basicForm.accountOpeningPermitFile[0];
                Data.personalCardFile = this.fileTransToString(this.basicForm.personalCardFile);

//                Data.personalCardFile = this.basicForm.personalCardFile[0];


                // luchun注释 草稿不需要验证
                // if (Data.registeredCountry == 1) {
                //     // 执照有效期
                //     if(this.value6&& (this.value6[0]!=null && this.value6[1]!=null)){
                //         var startTime = this.value6[0];
                //         var endTime = this.value6[1];
                //         Data.businessLicenseStartDate = new Date(startTime).getTime();
                //         Data.businessLicenseEndDate = new Date(endTime).getTime();
                //     }
                //     else {
                //         this.$message.error('请选择执照有效期');
                //         return;
                //     }
                // }


                // 执照有效期
//                var startTime = this.basicForm.dateTime[0];
//                var endTime = this.basicForm.dateTime[1]
//                Data.businessLicenseStartDate = new Date(startTime).getTime();
//                Data.businessLicenseEndDate = new Date(endTime).getTime();
//                console.log(Data.businessLicenseStartDate)
//                console.log(Data.businessLicenseEndDate)

                // 部门id
                if (this.supplierApplyCategories.length == 0) {
                    Data.categoryDeptId = '';
                    Data.supplierApplyCategories = [];
                } else {
                    Data.categoryDeptId = this.supplierApplyCategories[0].deptId;
                    Data.supplierApplyCategories = JSON.parse(JSON.stringify(this.supplierApplyCategories));
                   // Data.supplierApplyCategories = this.supplierApplyCategories;
                }




                // 是否为图书
                if (this.isBook) {
                    Data.categoryIsBook = 1
                } else if (this.supplierApplyCategories.length == 0) {
                    Data.categoryIsBook = 0
                } else {
                    Data.categoryIsBook = 0
                }

                // 品类图片转化成 字符串
                for (var i=0; i< Data.supplierApplyCategories.length;i++) {
                    Data.supplierApplyCategories[i].franchiseQualificationFile = this.fileTransToString(Data.supplierApplyCategories[i].franchiseQualificationFile)
                }

                $.ajax({
                    url: '/suppliers/supplierSettled/saveSupplierApply',
                    data: JSON.stringify(Data),
//                    data: JSON.stringify(data2),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            _this.$message({
                                message: '成功保存草稿',
                                type: 'success'
                            });
                            _this.basicForm.supplierApplyId = result.data.supplierApplyId;
                            window.sessionStorage["supplierApplyId"] = result.data.supplierApplyId;
                            _this.supplierApplyId = result.data.supplierApplyId;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            submitForm(formName) {
                var _this = this;
                var supplierApplyId = _this.supplierApplyId;
                if (supplierApplyId) {
                    this.supplierApplyId = _this.supplierApplyId;;
                }


                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log('submit!');

                        var _this = this;
                        var Data = {};
                        Data = JSON.parse(JSON.stringify(this.basicForm));
                        // Data.supplierApplyCategories = JSON.stringify(Data.supplierApplyCategories);
                        // 上传图片
//                        Data.publicationBusinessLicenseFile = this.basicForm.publicationBusinessLicenseFile[0];
//                        Data.businessLicenseFile = this.basicForm.businessLicenseFile[0];
//                        Data.orgCodeFile = this.basicForm.orgCodeFile[0];
//                        Data.taxFile = this.basicForm.taxFile[0];
//                        Data.accountOpeningPermitFile = this.basicForm.accountOpeningPermitFile[0];
//                        Data.personalCardFile = this.basicForm.personalCardFile[0];
                        Data.publicationBusinessLicenseFile = this.fileTransToString(this.basicForm.publicationBusinessLicenseFile);
                        Data.businessLicenseFile = this.fileTransToString(this.basicForm.businessLicenseFile);
                        Data.orgCodeFile = this.fileTransToString(this.basicForm.orgCodeFile);
                        Data.taxFile = this.fileTransToString(this.basicForm.taxFile);
                        Data.accountOpeningPermitFile = this.fileTransToString(this.basicForm.accountOpeningPermitFile);
                        Data.personalCardFile = this.fileTransToString(this.basicForm.personalCardFile);
                        if (Data.registeredCountry == 1) {
                            // 执照有效期
                            if(this.value6 && (this.value6[0]!=null && this.value6[1]!=null)){
                                var startTime = this.value6[0];
                                var endTime = this.value6[1];
                                Data.businessLicenseStartDate = new Date(startTime).getTime();
                                Data.businessLicenseEndDate = new Date(endTime).getTime();
                            }
                            else {
                                this.$message.error('请选择执照有效期');
                                return;
                            }

                        }

                        // 部门id
                        if (this.supplierApplyCategories.length == 0) {
                            Data.categoryDeptId = '';
                            Data.supplierApplyCategories = [];
                        } else {
                            Data.categoryDeptId = this.supplierApplyCategories[0].deptId;
                            Data.supplierApplyCategories = JSON.parse(JSON.stringify(this.supplierApplyCategories));
                        }

                        

                        if (this.basicForm.officeCountry ==1) {
                            if (!this.basicForm.officeProvince || !this.basicForm.officeCity || !this.basicForm.officeDistrict) {
                                this.$message.error('请选择办公地址');
                                return;
                            }
                        }
                        if (this.basicForm.registeredCountry ==1) {
                            if (!this.basicForm.registeredProvince || !this.basicForm.registeredCity || !this.basicForm.registeredDistrict) {
                                this.$message.error('请选择注册地址');
                                return;
                            }
                        }
                        if (this.supplierApplyCategories.length == 0) {
                            this.$message.error('请添加主营品类');
                            return;
                        } else {
                            // 是否为图书
                            if (Data.supplierApplyCategories[0].category.grandId == 2110) {
                                Data.categoryIsBook = 1
                            } else if (this.supplierApplyCategories.length == 0) {
                                Data.categoryIsBook = 0
                            } else {
                                Data.categoryIsBook = 0
                            }
                        }


                        if (
                            this.basicForm.businessLicenseFile.length ==0 ||
                            this.basicForm.accountOpeningPermitFile.length ==0 ||
                            this.basicForm.personalCardFile.length ==0) {
                            this.$message.error('请上传相关资质图片');
                            return;
                        }
                        for (var i=0; i< Data.supplierApplyCategories.length;i++) {
                            console.log(Data.supplierApplyCategories);
                            Data.supplierApplyCategories[i].franchiseQualificationFile = this.fileTransToString(Data.supplierApplyCategories[i].franchiseQualificationFile)
                            if (Data.supplierApplyCategories[i].franchiseQualification == true) {
                                if (Data.supplierApplyCategories[i].franchiseQualificationFile == '') {
                                    this.$message.error('请上传品类经营特许资质电子版');
                                    return;
                                }
                            }
                        }
                        if (Data.registeredCapital == 0) {
                            this.$message.error('注册资金不能为0');
                            return;
                        }
                        if (Data.licenseType == 1) {
                            if(!Data.orgCode){
                                this.$message.error('请填写组织机构代码');
                                return;
                            }
                        }
                        if (Data.registeredCountry ==1) {
                            if (!this.value6) {
                                this.$message.error('请选择执照有效期');
                                return;
                            }
                        }



                        $.ajax({
                            url: '/suppliers/supplierSettled/submitSupplierApply',
                            data: JSON.stringify(Data),
//                            data: JSON.stringify(data2),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (!result.code) {
                                    if (_this.basicForm.registeredCountry == 1) {
                                        window.sessionStorage["registeredCountry"] = 1
                                    } else {
                                        window.sessionStorage["registeredCountry"] = _this.basicForm.registeredCountry;
                                    }

                                    window.sessionStorage["supplierApplyId"] = result.data.supplierApplyId;
                                    // 后台成功 改变路由
                                    _this.$router.push({
                                        path:'/edit_info_brand?supplierApplyId=' + result.data.supplierApplyId
                                    })
                                } else {
                                    _this.$message({
                                        showClose: true,
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

        },

        mounted () {
            this.$nextTick(function () {

                //var arr = this.fileTrans('sadasdas');



//                this.basicForm.dateTime = ["2017-05-01","2017-09-01"]

//                this.basicForm.businessLicenseFile = [{url:"http://img1.bravetime.net/supplier/2017/05/14/640_640_c8a063d4fb60a4de4105870faa02aea8.png"}]
                var _this = this;
                $('.sign .el-form-item__content').css({"marginLeft": "0px"});
                $('table tr:eq(1) .cell').css({"color": "#ff3d70", "font-size": "12px"});
                this.basicForm.officeCountry = 1;
                this.getAddress();
                this.getCategory();
                this.fetch();

            })
        },
        computed: {
            amount: function () {
                return 200 - this.basicForm.supplierIntro.length;
            }
        },
        watch: {
            'basicForm.licenseType': function (val) {
                if (val == 2 || val == 3) {
                    this.basicForm.orgCode = '';
                    this.basicForm.orgCodeFile = [];
                    this.basicForm.taxFile = [];
                }
            },

            'basicForm.publicationBusinessLicenseFile': function (val) {
                if (val.length > 0) {
                    this.pic_1 = false;
                } else {
                    this.pic_1 = true;
                }
            },
            'basicForm.businessLicenseFile': function (val) {
                if (val.length > 0) {
                    this.pic_2 = false;
                } else {
                    this.pic_2 = true;
                }
            },
            'basicForm.orgCodeFile': function (val) {
                if (val.length > 0) {
                    this.pic_3 = false;
                } else {
                    this.pic_3 = true;
                }
            },
            'basicForm.taxFile': function (val) {
                if (val.length > 0) {
                    this.pic_4 = false;
                } else {
                    this.pic_4 = true;
                }
            },
            'basicForm.accountOpeningPermitFile': function (val) {
                if (val.length > 0) {
                    this.pic_5 = false;
                } else {
                    this.pic_5 = true;
                }
            },
            'basicForm.personalCardFile': function (val) {
                if (val.length > 0) {
                    this.pic_6 = false;
                } else {
                    this.pic_6 = true;
                }
            },
            'basicForm.registeredCountry': function (val) {
                if(val != 1) {
                    this.value6 = null;
                }
            }

        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 91%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }

        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 87%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }

        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }

        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }
        .edit_wrap {
            margin: 50px auto;
            width: 1050px;
            border: 1px solid #eee;
            .edit_tab {
                display: inline-block;
                width: 262px;
                height: 46px;
                background: #ff6c83;
                color: #fff;
                text-align: center;
                line-height: 46px;
            }
            .active_tab {
                background: #ff4a7d;
            }
            .tip_word {
                margin-top: 20px;
                padding: 10px;
                width: 1048px;
                height: 160px;
                background: #f9f9f9;
            }
        }
        .fixeds {
            position: absolute;
            top: 37px;
            right: 69px;
            z-index: 2;
            width: 148px;
            height: 148px;
            background: #fff;
        }
        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }
        .rule_star {
            position: relative;
            left:-76px;
        }
        .rule_star2 {
            position: relative;
            left:-120px;
        }
        .rule_star3 {
            position: relative;
            left:-190px;
        }
        .rule_star4 {
            position: relative;
            left:-132px;
        }
        .rule_star5 {
            position: relative;
            left:-160px;
        }
        .rule_star6 {
            position: relative;
            left:-150px;
        }
        .rule_star200 {
            position: relative;
            left:-200px;
        }
        .rule_star105 {
            position: relative;
            left:-105px;
        }
        .ml_10 {
            margin-left: -10px;
        }
        .lh20 {
            line-height: 20px;
        }
</style>


// WEBPACK FOOTER //
// basicInfo.vue?e88b1186